"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiEventResponseDto = void 0;
const class_transformer_1 = require("class-transformer");
const billing_api_charge_event_response_dto_1 = require("../../../billing-api-charge/types/dtos/billing-api-charge-event-response.dto");
const billing_api_contractor_event_response_dto_1 = require("../../../billing-api-contractor/types/dtos/billing-api-contractor-event-response.dto");
const billing_core_charge_event_type_enum_1 = require("../../../../billing-core/billing-core-charge/types/enums/billing-core-charge-event-type.enum");
const billing_api_supplier_changed_event_response_dto_1 = require("../../../billing-api-supplier/types/dtos/billing-api-supplier-changed-event-response.dto");
const billing_core_customer_changed_event_type_enum_1 = require("../../../../billing-core/billing-core-customer/types/enums/billing-core-customer-changed-event-type.enum");
const billing_core_supplier_changed_event_type_enum_1 = require("../../../../billing-core/billing-core-supplier/types/enums/billing-core-supplier-changed-event-type.enum");
const billing_api_event_data_base_response_dto_1 = require("./billing-api-event-data-base-response.dto");
const types_1 = require("../../../billing-api-customer/types");
const merged = {
  ...billing_core_charge_event_type_enum_1.BillingCoreChargeEventTypeEnum,
  ...billing_core_supplier_changed_event_type_enum_1.BillingCoreSupplierChangedEventTypeEnum,
  ...billing_core_customer_changed_event_type_enum_1.BillingCoreCustomerChangedEventTypeEnum
};
class BillingApiEventResponseDto {}
__decorate([(0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiEventResponseDto.prototype, "id", void 0);
__decorate([(0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiEventResponseDto.prototype, "type", void 0);
__decorate([(0, class_transformer_1.Expose)(), (0, class_transformer_1.Type)(() => billing_api_event_data_base_response_dto_1.BillingApiEventDataBaseResponseDto, {
  discriminator: {
    property: '__type',
    subTypes: [{
      value: billing_api_charge_event_response_dto_1.BillingApiChargeEventResponseDto,
      name: billing_api_charge_event_response_dto_1.BillingApiChargeEventResponseDto.name
    }, {
      value: billing_api_contractor_event_response_dto_1.BillingApiContractorEventResponseDto,
      name: billing_api_contractor_event_response_dto_1.BillingApiContractorEventResponseDto.name
    }, {
      value: billing_api_supplier_changed_event_response_dto_1.BillingApiSupplierChangedEventResponseDto,
      name: billing_api_supplier_changed_event_response_dto_1.BillingApiSupplierChangedEventResponseDto.name
    }, {
      value: types_1.BillingApiCustomerChangedEventResponseDto,
      name: types_1.BillingApiCustomerChangedEventResponseDto.name
    }]
  }
}), __metadata("design:type", Object)], BillingApiEventResponseDto.prototype, "data", void 0);
exports.BillingApiEventResponseDto = BillingApiEventResponseDto;
